import DeletePopUp from './DeletePopUp';

export default DeletePopUp;
